// setting pose data collection frequency for score calculation.
export const COLLECTION_FREQUENCY = process.env.VUE_APP_POSE_DATA_COLLECTION_FREQUENCY ?? 3

//setting required number of frames per second.
export const POSE_FRAME_COUNT_PER_SECOND = process.env.VUE_APP_POSE_DATA_FRAMES_PER_SECOND ?? 5

export const POSE_FRAME_COUNT_PER_SECOND_ASSESSMENT = process.env.VUE_APP_POSE_DATA_FRAMES_PER_SECOND_ASSESSMENT ?? 15

// setting time should overlap or not
export const IS_OVERLAP_TIME = process.env.VUE_APP_POSE_DATA_IS_OVERLAP_TIME ?? "true"

//enable pose data fetch from db or not
export const POSE_DATA_FETCH_FROM_DB = process.env.VUE_APP_ENABLE_POSE_DATA_FETCH_FROM_DB ?? "true"

export const DEFAULT_VIDEOS = process.env.VUE_APP_DEFAULT_VIDEOS ?? "[98,106]"

export const MOBILE_DEMO_VIDEO_IDS = JSON.parse(process.env.VUE_APP_MOBILE_DEMO_VIDEO_IDS)

export const DESKTOP_DEMO_VIDEO_IDS = JSON.parse(process.env.VUE_APP_DESKTOP_DEMO_VIDEO_IDS)

export const PAUSE_VIDEO_CHECK_INTERNAL = process.env.VUE_PAUSE_VIDEO_CHECK_INTERNAL ?? "{\"mobile\": 7000, \"default\": 4000}"

export const FIT_SUMMIT_DEMO_VIDEO_IDS = process.env.VUE_APP_FITSUMMIT_PAGE_TEAM_VIDEOS ?? "182,1667,103"